// CSPM-4003: publicRuntimeConfig was purged of secrets (JWT_SECRET, CRYPTO_PASSWORD, etc.).
// RECAPTCHA_KEY and IDENTITY_API_KEY are public-facing keys safe for __NEXT_DATA__ exposure;
// they are read from publicRuntimeConfig so they resolve at runtime (via secretsLoader) with
// no Docker build arg required.

const { publicRuntimeConfig = {} } = require("next/config").default() || {};

const getEnvConfig = {
  EDIT_PROFILE_URL_FOR_DOTREALTOR: "https://dashboard.realtor.com",

  EDIT_PROFILE_URL_FOR_NON_DOTREALTOR: `https://identity.move.com/login/move?app_id=control_panel&apikey=${publicRuntimeConfig.IDENTITY_API_KEY}&return_uri=/profile/settings/profile`,
  CLAIM_PROFILE_URL:
    "https://identity.move.com/signup/move/new?app_id:control_panel&return_uri:/profile/settings/profile/",

  SHARE_URL: "https://www.realtor.com",
  RECAPTCHA_KEY: publicRuntimeConfig.RECAPTCHA_KEY,
  LISTING_BASE_URL: "https://www.realtor.com",
  MY_ACCT_BASE_URI: "https://myaccount.realtor.com",
  LOG_LEVEL: "ERROR",
  ENVIRONMENT: "production",
  RDC_X_API_PUBLIC: "https://www.realtor.com",
  FRONTDOOR_CLIENT: "https://api.frontdoor.realtor.com",
};

module.exports = getEnvConfig;
